<div class="table-panel">
    <!-- <div class="table-panel__toolbar">
        <app-table-toolbar
            [placeholder]="placeholder()"
            [buttons]="toolbarButtons()"
            (actionClick)="toolbarAction.emit($event)"
            (searchValueChange)="searchValueChange.emit($event)">
            <div leftActions class="toolbar-actions-wrapper">
                <ng-content select="[toolbar-actions]"></ng-content>
            </div>
        </app-table-toolbar>
    </div> -->

    <div class="table-panel__table main-table-container">
        <app-table
            [columns]="columns()"
            [data]="data()"
            [loading]="loading()"
            [tableTitle]="tableTitle()"
            [tableHeight]="tableHeight()"
            [hasCheckBox]="hasCheckBox()"
            [showColumnSettings]="showColumnSettings()"
            (actionClick)="actionClick.emit($event)"
            (cellClick)="cellClick.emit($event)"
            (selectionChange)="selectionChange.emit($event)" />
    </div>
</div>
